import { createApp } from 'vue'
import axios from 'axios'
import Swal from 'sweetalert2'

import App from './App.vue'
import router from "./router";
import BootstrapVue3 from 'bootstrap-vue-3';
import VueApexCharts from "vue3-apexcharts";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from 'vue3-scroll-spy';

import Maska from 'maska'
import {i18n} from "./i18n.js"
import { initFirebaseBackend } from './authUtils'
import { configureFakeBackend } from './helpers/fake-backend';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css';

import store from "./state/store";

import "../src/design/app.scss";

axios.defaults.withCredentials = true;

if (window.location.hostname === "toofacyl.com") {
  window.location.replace(`https://www.toofacyl.com${window.location.pathname}${window.location.search}${window.location.hash}`);
}

const toofacylAlert = Swal.mixin({
  buttonsStyling: false,
  showClass: {
    popup: "toofacyl-alert-show",
    backdrop: "toofacyl-alert-backdrop-show",
    icon: "toofacyl-alert-icon-show",
  },
  hideClass: {
    popup: "toofacyl-alert-hide",
    backdrop: "toofacyl-alert-backdrop-hide",
    icon: "toofacyl-alert-icon-hide",
  },
  customClass: {
    container: "toofacyl-alert-container",
    popup: "toofacyl-alert",
    title: "toofacyl-alert-title",
    htmlContainer: "toofacyl-alert-content",
    icon: "toofacyl-alert-icon",
    actions: "toofacyl-alert-actions",
    confirmButton: "toofacyl-alert-button toofacyl-alert-confirm",
    cancelButton: "toofacyl-alert-button toofacyl-alert-cancel",
    denyButton: "toofacyl-alert-button toofacyl-alert-deny",
    input: "toofacyl-alert-input",
  },
});

Swal.fire = toofacylAlert.fire.bind(toofacylAlert);

const SESSION_EXPIRED_MESSAGE_KEY = "sessionExpiredMessage";
let lastNetworkAlertAt = 0;

function showNetworkAlert() {
  const now = Date.now();
  if (now - lastNetworkAlertAt < 6000) {
    return;
  }

  lastNetworkAlertAt = now;
  Swal.fire(
    "Sin conexión con el servidor",
    "No se pudo conectar con el backend. Verifica que esté levantado e intenta nuevamente.",
    "warning"
  );
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error && error.response ? error.response.status : null;
    const responseData = error && error.response ? error.response.data || {} : {};
    const responseMessage = String(responseData.msg || responseData.message || "").toLowerCase();
    const isNetworkError = !error.response && (!error.request || error.message === "Network Error" || error.code === "ERR_NETWORK");
    const isSessionExpired =
      status === 401 ||
      (status === 403 && (
        responseMessage.includes("sesión caducada") ||
        responseMessage.includes("sesion caducada") ||
        responseMessage.includes("session expired") ||
        responseMessage.includes("jwt expired") ||
        responseMessage.includes("invalid token") ||
        responseMessage.includes("no authorization token")
      ));

    if (isNetworkError) {
      showNetworkAlert();
      return new Promise(() => {});
    }

    if (isSessionExpired) {
      const redirectFrom = `${window.location.pathname}${window.location.search}${window.location.hash}`;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      sessionStorage.setItem(
        SESSION_EXPIRED_MESSAGE_KEY,
        "Tu sesión expiró o ya no es válida. Ingresa nuevamente para continuar."
      );

      if (window.location.pathname !== "/login") {
        router.replace({ path: "/login", query: { redirectFrom } }).catch(() => {});
      }

      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);


createApp(App)
  .use(store)
  .use(router)
  .use(require('vue-chartist'))
  .use(BootstrapVue3)
  .use(VueApexCharts)
  .use(vClickOutside)
  .use(i18n)
  .use(registerScrollSpy)
  .use(Maska)
  .mount('#app')
